var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDestinationIcon = function SvgDestinationIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.95px)",
      clipPath: "url(#bgblur_0_11518_144834_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9948 30C21.8281 24.4 27.6615 19.3856 27.6615 13.2C27.6615 7.01441 22.4381 2 15.9948 2C9.55147 2 4.32812 7.01441 4.32812 13.2C4.32812 19.3856 10.1615 24.4 15.9948 30Z",
    fill: "#5547DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1739 19.4997H12.301V17.6675H15.0675C15.8529 17.6675 16.5091 17.5213 17.036 17.229C17.5681 16.9314 17.9658 16.4851 18.2293 15.8901C18.4979 15.295 18.6321 14.5511 18.6321 13.6585C18.6321 12.7659 18.5004 12.0247 18.2369 11.4348C17.9734 10.8449 17.5807 10.4039 17.0589 10.1115C16.537 9.81399 15.8909 9.66522 15.1207 9.66522H12.2402V7.83301H15.2423C16.3672 7.83301 17.3325 8.0653 18.1381 8.52988C18.9488 8.99445 19.5721 9.66261 20.0078 10.5343C20.4436 11.4061 20.6615 12.4475 20.6615 13.6585C20.6615 14.8695 20.4436 15.9135 20.0078 16.7905C19.5721 17.6622 18.9438 18.333 18.1229 18.8028C17.3071 19.2674 16.3241 19.4997 15.1739 19.4997ZM13.3802 7.83301V19.4997H11.3281V7.83301H13.3802Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11518_144834_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDestinationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "DestinationIcon.4ebac52b6a6eca92df43e15e159651a5.svg";